import mutations from './sapRiports.mutations'
import actions from './sapRiports.actions'
import getters from './sapRiports.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
